import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const ServicesPage = () => {
  const commissions = [
    {
      id: 'wild-spirit',
      title: null,
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/7255a5d0-46bc-41df-bf8c-2af326e14ca1/IMG_6161.jpg",
      alt: "Wild Spirit Horse",
      quote: "I recently purchased this stunning painting, and I couldn't be more thrilled with my choice. This artwork has become a focal point in my home, sparking conversation and inspiring awe among guests. It's not just a piece of art; it feels like a reflection of wild spirit and nature's beauty. I highly recommend it to anyone looking to bring a touch of vibrancy and grace into their space!",
      author: "Anonymous"
    },
    {
      id: 'hidden-wounds',
      title: 'Hidden Wounds',
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/4d717ce2-0c18-4bd5-94af-55f3ec4e0e35/Hidden+Wounds-highres-20241110-fotor-2024112714116.jpg",
      alt: "Hidden Wounds",
      quote: "I am absolutely thrilled to share that I won this magnificent painting at a recent private charity auction! The moment I laid eyes on it, I felt an undeniable connection to the piece. The artist's ability to capture the nuances of the human form, combined with the thoughtful use of light and shadow, creates a powerful narrative of vulnerability and introspection. It's not just a depiction of the human body; it evokes a sense of emotion and contemplation that resonates deeply. This artwork has found a special place in my home, and I can't help but admire it daily.",
      author: "Private Bidder"
    },
    {
      id: 'lovers-kiss',
      title: "The Lover's Kiss",
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/b27d4c4a-76cb-43e0-9aea-dbdefa65b94c/The+Lovers+Kiss-highRes-20241110-fotor-202411271446.jpg",
      alt: "The Lover's Kiss",
      quote: "I had the privilege of adding The Lover's Kiss by Leigh Witherell to my collection, and it has quickly become the centerpiece of my home. The piece is absolutely stunning capturing the intimate, timeless feeling of looking out into a moment shared between two lovers along the Mediterranean. What makes it even more special is the way it's displayed. The unique hanging that Leigh's work specialises draws your eye from the side first, creating a sense of discovery before you're met with the full beauty from the front. It's truly unlike anything else I own. Every guest who visits comments on it, it's the artwork that gets the most attention and admiration in my condo. Leigh has an excellent ability to create something both personal and universal, full of movement and soul. I feel fortunate to have found her at this stage of her career, and I'm excited to watch her continue to grow and collaborate with other artists….",
      author: "Alle Shane"
    },
    {
      id: 'sara',
      title: null,
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/255cb555-da1f-4f11-8e4b-4f66c3cb1552/Sara.JPG",
      alt: "Sara Portrait",
      quote: "My kids and I were seriously unprepared for the effect that painting has on you in person! I get why people were spellbound! Leigh the portrait is compelling and stunning! I cannot adequately express how much your gift means to us.",
      author: "Connie Dell"
    },
    {
      id: 'wreck',
      title: null,
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/f60d9b5c-17a9-4d89-b0be-92cbf8fbee1d/The+Wreck+-+MedLowRes+-+20250103.jpg",
      alt: "The Wreck",
      quote: "…The water and boats are Joe's favorites things. It looks amazing on the wall near the front door. Every time someone walks into the house they stop and stare at the painting. They couldn't believe what an incredible painter you are…",
      author: "April and Joe Dallara"
    },
    {
      id: 'pirate-ship',
      title: 'The Pirate Ship',
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/d10dbe9f-3218-4a09-831b-264ad6d48c17/Pirate+ship+18x24+SOLD.jpg",
      alt: "The Pirate Ship",
      note: "The Pirate Ship was gifted to a dear family member."
    },
    {
      id: 'kat',
      title: 'Kat',
      image: "https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/4cf8bff2-043d-4d0c-8ace-d73dc051563d/Kat-MedHiRes.JPG",
      alt: "Kat",
      note: '"Kat" is a commissioned piece done in remembrance of a daughter gone too soon.'
    }
  ];

  return (
    <div className="min-h-screen bg-off-black">
      <Navigation />

      {/* Content */}
      <div className="pt-24 sm:pt-28 md:pt-32 pb-16 sm:pb-24 md:pb-32 px-4 sm:px-6">
        <div className="max-w-5xl mx-auto">
          {/* Page Title */}
          <div className="mb-12 sm:mb-16 md:mb-24">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif text-soft-ivory tracking-tight mb-3 sm:mb-4">
              Commission Works
            </h1>
            <div className="w-16 sm:w-20 h-1 bg-flesh-tone mb-8 sm:mb-12"></div>

            <p className="text-base sm:text-lg md:text-xl leading-relaxed text-soft-ivory max-w-3xl italic">
              "Imagine a piece of art that captures not just a moment, but the essence of your journey—your dreams, your struggles, your triumphs. By commissioning a unique work from me, you're inviting me into your world, where together we can weave your story into a visual tapestry. Let's create something that resonates with your heart, a piece that you can cherish and share for years to come, reflecting your soul's true colors."
            </p>
          </div>

          {/* Commission Examples and Reviews */}
          <section className="mb-20 sm:mb-24 md:mb-32">
            <h2 className="text-xs uppercase tracking-widest text-muted-warm-grey mb-10 sm:mb-12 md:mb-16">
              Recent Commissions & Reviews
            </h2>

            <div className="space-y-20 sm:space-y-24 md:space-y-32">
              {commissions.map((c) => (
                <div key={c.id} className="max-w-3xl">
                  <img
                    src={c.image}
                    alt={c.alt}
                    className="w-full h-auto mb-6 sm:mb-8 border border-zinc-800"
                  />
                  {c.title && (
                    <p className="text-xs uppercase tracking-widest text-muted-warm-grey mb-4 sm:mb-6">{c.title}</p>
                  )}
                  {c.quote ? (
                    <div className="border-l-2 border-flesh-tone pl-4 sm:pl-8">
                      <blockquote className="text-base sm:text-lg leading-relaxed text-soft-ivory mb-4 sm:mb-6 italic">
                        "{c.quote}"
                      </blockquote>
                      <cite className="not-italic text-muted-warm-grey text-sm">— {c.author}</cite>
                    </div>
                  ) : (
                    <p className="text-base sm:text-lg leading-relaxed text-soft-ivory pl-4 sm:pl-8 border-l-2 border-flesh-tone">
                      {c.note}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ServicesPage;
